module.exports = __webpack_public_path__ + "img/dang6.07985148.png";